import { Navigate } from 'react-router-dom';
import { useUserStore } from '../../features/auth/store/userStore';
import { hasRole } from '../../shared/constants/roles';

/**
 * RoleGuard component - restricts route access based on user roles
 * @param {React.ReactNode} children - Component to render if user has required role
 * @param {string|string[]} requiredRoles - Role(s) required to access this route
 */
export function RoleGuard({ children, requiredRoles }) {
  const { roles } = useUserStore();

  // Normalize requiredRoles to array
  const rolesArray = Array.isArray(requiredRoles) ? requiredRoles : [requiredRoles];

  // Check if user has any of the required roles
  const hasRequiredRole = rolesArray.some(role => hasRole(roles, role));

  if (!hasRequiredRole) {
    // Redirect to dashboard if user doesn't have required role
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
